
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta } from "/opt/build/repo/pages/login.vue?macro=true";
import { default as confirmtfJjcehsAXgzDoakAZcw6ceepd_45_Z6xWt3OaWc4DvHwMeta } from "/opt/build/repo/pages/confirm.vue?macro=true";
import { default as _91id_932fPt0NzKayOW84KahGtG_45Rdx4VZKsLjNYzPrebGqLhgMeta } from "/opt/build/repo/pages/org/[id].vue?macro=true";
import { default as scheduleP5uxmXLjUPH6fPBstWHzkhtOFsc74LnG3l67Gtx_22AMeta } from "/opt/build/repo/pages/schedule.vue?macro=true";
import { default as settingsYa9S1YcDD9UMaj5ELJs67gQjD0lYJ2UoIw9mzh67w2cMeta } from "/opt/build/repo/pages/settings.vue?macro=true";
import { default as _91id_93Y4Sx65vvyjRdrh6k7medMiL1B55MPcsDWPAFZcnBJNgMeta } from "/opt/build/repo/pages/people/[id].vue?macro=true";
import { default as indexEVOP_aPKk8sfXL_UWlkpAKz5s9qe74EITg8TTFzJMA4Meta } from "/opt/build/repo/pages/events/index.vue?macro=true";
import { default as indexloAEjyGKNNxrmtH8__45TqCIv_Jsuv7LR19KyUtTw_45FPwMeta } from "/opt/build/repo/pages/people/index.vue?macro=true";
import { default as transactionsCsDUKgyUI6HF5QTn6L9zINLhnDBGodbdMSsq4mpD__cMeta } from "/opt/build/repo/pages/transactions.vue?macro=true";
import { default as indexOEKw2ycg9cRLOtvTr_VzU58ZM4AeNWreCXNCD4wj7d8Meta } from "/opt/build/repo/pages/segments/index.vue?macro=true";
import { default as calendly_45importU1V5ZAYp1llwtzHzAEVQGjxPYSZSiFMeNdGTjhowpGMMeta } from "/opt/build/repo/pages/calendly-import.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta || {},
    component: () => import("/opt/build/repo/pages/login.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    meta: confirmtfJjcehsAXgzDoakAZcw6ceepd_45_Z6xWt3OaWc4DvHwMeta || {},
    component: () => import("/opt/build/repo/pages/confirm.vue")
  },
  {
    name: "org-id",
    path: "/org/:id()",
    meta: _91id_932fPt0NzKayOW84KahGtG_45Rdx4VZKsLjNYzPrebGqLhgMeta || {},
    component: () => import("/opt/build/repo/pages/org/[id].vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    component: () => import("/opt/build/repo/pages/schedule.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/opt/build/repo/pages/settings.vue")
  },
  {
    name: "people-id",
    path: "/people/:id()",
    component: () => import("/opt/build/repo/pages/people/[id].vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/opt/build/repo/pages/events/index.vue")
  },
  {
    name: "people",
    path: "/people",
    component: () => import("/opt/build/repo/pages/people/index.vue")
  },
  {
    name: "transactions",
    path: "/transactions",
    component: () => import("/opt/build/repo/pages/transactions.vue")
  },
  {
    name: "segments",
    path: "/segments",
    component: () => import("/opt/build/repo/pages/segments/index.vue")
  },
  {
    name: "calendly-import",
    path: "/calendly-import",
    component: () => import("/opt/build/repo/pages/calendly-import.vue")
  }
]